/**
 * @generated SignedSource<<1efd437deb678fe83b730c7edb8e66f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormulaSetId_formulaSetQuery$variables = {
  id: string;
};
export type FormulaSetId_formulaSetQuery$data = {
  readonly formulaSet: {
    readonly created: any;
    readonly createdBy: {
      readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
    };
    readonly description: string | null;
    readonly formulas: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly text: string;
          readonly title: string;
        };
      }>;
      readonly totalCount: number | null;
    };
    readonly id: string;
    readonly next: string | null;
    readonly previous: string | null;
    readonly sequence: number;
    readonly unitD: {
      readonly title: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"FormulaSetFormulaSetHistoryPaginator_formulaSet" | "FormulaSetMutationActionsButtonStack_formulaSet" | "FormulaSetStatusLabel_formulaSet">;
  };
};
export type FormulaSetId_formulaSetQuery = {
  response: FormulaSetId_formulaSetQuery$data;
  variables: FormulaSetId_formulaSetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previous",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "next",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "FormulaConnection",
  "kind": "LinkedField",
  "name": "formulas",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FormulaEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Formula",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormulaSetId_formulaSetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormulaSet",
        "kind": "LinkedField",
        "name": "formulaSet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "unitD",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserAvatarText_user"
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FormulaSetStatusLabel_formulaSet"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FormulaSetMutationActionsButtonStack_formulaSet"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FormulaSetFormulaSetHistoryPaginator_formulaSet"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormulaSetId_formulaSetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormulaSet",
        "kind": "LinkedField",
        "name": "formulaSet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "unitD",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unitATitle",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "FormulaSetHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormulaSetHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormulaSetHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v2/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormulaDifference",
                                "kind": "LinkedField",
                                "name": "formulas",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "text",
                                    "plural": false,
                                    "selections": (v16/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "title",
                                    "plural": false,
                                    "selections": (v16/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "FormulaSetDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "filters": [
              "order"
            ],
            "handle": "connection",
            "key": "FormulaSetFormulaSetHistoryPaginator_formulaSet_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6879be05f04b32871f23eb2b884b075c",
    "id": null,
    "metadata": {},
    "name": "FormulaSetId_formulaSetQuery",
    "operationKind": "query",
    "text": "query FormulaSetId_formulaSetQuery(\n  $id: ID!\n) {\n  formulaSet(id: $id) {\n    id\n    sequence\n    previous\n    next\n    unitD {\n      title\n      id\n    }\n    formulas {\n      edges {\n        node {\n          id\n          title\n          text\n        }\n      }\n      totalCount\n    }\n    description\n    createdBy {\n      ...UserAvatarText_user\n      id\n    }\n    created\n    ...FormulaSetStatusLabel_formulaSet\n    ...FormulaSetMutationActionsButtonStack_formulaSet\n    ...FormulaSetFormulaSetHistoryPaginator_formulaSet\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment FormulaDifferenceItemList_formulaDifference on FormulaDifference {\n  text {\n    ...DiffItem_diff\n  }\n  title {\n    ...DiffItem_diff\n  }\n}\n\nfragment FormulaSetDifferenceItemList_formulaSetDifference on Difference {\n  __isDifference: __typename\n  ... on FormulaSetDifference {\n    formulas {\n      ...FormulaDifferenceItemList_formulaDifference\n    }\n    description {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment FormulaSetFormulaSetHistoryPaginator_formulaSet on FormulaSet {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...FormulaSetHistoryDialog_formulaSetHistory\n        ...FormulaSetHistoryTimelineItem_formulaSetHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment FormulaSetHistoryDialog_formulaSetHistory on FormulaSetHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...FormulaSetDifferenceItemList_formulaSetDifference\n  }\n}\n\nfragment FormulaSetHistoryTimelineItem_formulaSetHistory on FormulaSetHistory {\n  id\n  createdBy {\n    ...UserAvatarText_user\n    id\n  }\n  created\n  type\n}\n\nfragment FormulaSetMutationActionsButtonStack_formulaSet on FormulaSet {\n  id\n  actions\n  ...FormulaSetUpdateDialog_formulaSet\n}\n\nfragment FormulaSetStatusLabel_formulaSet on FormulaSet {\n  status\n}\n\nfragment FormulaSetUpdateDialog_formulaSet on FormulaSet {\n  id\n  description\n  unitD {\n    unitATitle\n    title\n    id\n  }\n  formulas {\n    totalCount\n    edges {\n      node {\n        title\n        text\n        id\n      }\n    }\n  }\n  ...FormulaSetStatusLabel_formulaSet\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "d27d6bcf2e34c8745753bf3cf7b0d747";

export default node;
